'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var dist = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

(function (AccountType) {
  // FSA account types
  AccountType["FSADC"] = "FSADC";
  AccountType["FSAHC"] = "FSAHC";
  AccountType["FSALP"] = "FSALP"; // HSA account types

  AccountType["HSA"] = "HSA";
})(exports.AccountType || (exports.AccountType = {}));

var ClaimType;

(function (ClaimType) {
  ClaimType["MEDICAL"] = "MEDICAL";
  ClaimType["RX"] = "RX";
  ClaimType["DENTAL"] = "DENTAL";
})(ClaimType || (ClaimType = {}));

(function (AccountSystemCode) {
  AccountSystemCode["CAMS"] = "CAMS";
  AccountSystemCode["OptumBank"] = "OPTUM_BANK";
  AccountSystemCode["WEX"] = "WEX";
})(exports.AccountSystemCode || (exports.AccountSystemCode = {}));

(function (MessageType) {
  MessageType["CleanUp"] = "CleanUp";
  MessageType["Submit"] = "Submit";
})(exports.MessageType || (exports.MessageType = {}));

function handleMessageFactory(postMessage, originList) {
  return function (event) {
    // Important: ignore messages from other origins
    if (originList.indexOf(event.origin) > -1) {
      postMessage(event.data);
    }
  };
}

exports.handleMessageFactory = handleMessageFactory;
});

unwrapExports(dist);
var dist_1 = dist.AccountType;
var dist_2 = dist.AccountSystemCode;
var dist_3 = dist.MessageType;
var dist_4 = dist.handleMessageFactory;

var validWidgetSourceSuffixes = ['rally-dev.com', 'werally.in', 'rally.com', 'localhost:1977'];
function determineEnvironment(environment) {
  var isValid = validWidgetSourceSuffixes.find(function (source) {
    return environment.indexOf(source) > -1;
  });

  if (isValid) {
    return environment;
  }

  return undefined;
}

var urlSearchParams_node = createCommonjsModule(function (module) {

function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else if (query.forEach) {
      query.forEach(addEach, dict);
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function addEach(value, key) {
  /* jshint validthis:true */
  appendTo(this, key, value);
}

function appendTo(dict, name, value) {
  var res = isArray(value) ? value.join(',') : value;
  if (name in dict)
    dict[name].push(res);
  else
    dict[name] = [res];
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = commonjsGlobal.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));
});

// see: https://caniuse.com/#feat=urlsearchparams
function generateIframePath(root, urlParams) {
  var claimsInfoPacket = urlParams.claimsInfoPacket,
      locale = urlParams.locale,
      token = urlParams.token;
  var params = new urlSearchParams_node();
  params.set('claimsInfoPacket', JSON.stringify(claimsInfoPacket));
  params.set('locale', locale);
  params.set('token', token);
  return "".concat(root, "/?").concat(params.toString());
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var RallyPayError =
/*#__PURE__*/
function (_Error) {
  _inherits(RallyPayError, _Error);

  function RallyPayError(message) {
    var _this;

    _classCallCheck(this, RallyPayError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RallyPayError).call(this, "[RallyPay Library]: ".concat(message)));
    _this.name = 'RallyPayError';
    return _this;
  }

  return RallyPayError;
}(_wrapNativeSuper(Error));

var RallyPay = {
  create: function create(rallyPayConfigs) {
    var claimsInfoPacket = rallyPayConfigs.claimsInfoPacket,
        environment = rallyPayConfigs.environment,
        locale = rallyPayConfigs.locale,
        onSubmit = rallyPayConfigs.onSubmit,
        token = rallyPayConfigs.token,
        container = rallyPayConfigs.container;
    var iFrameHostname = determineEnvironment(environment);

    if (!iFrameHostname) {
      throw new RallyPayError('Widget not found! Please provide a valid environment.');
    }

    if (!(container instanceof HTMLElement)) {
      throw new RallyPayError('Invalid container! ');
    }

    var iframe = document.createElement('iframe');
    iframe.src = generateIframePath(iFrameHostname, {
      claimsInfoPacket: claimsInfoPacket,
      locale: locale,
      token: token
    });
    container.appendChild(iframe);
    var handleMessage = dist_4(onSubmit, [iFrameHostname]);
    window.addEventListener('message', handleMessage, false); // return a RallyPay js instance.

    return {
      cleanup: function cleanup() {
        window.removeEventListener('message', handleMessage);
      },
      postMessage: function postMessage(message) {
        // contentWindow is only set after the iframe has loaded, in most cases this is enough
        // otherwise, we can add messages to a queue and post them once iframe loaded.
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(message, iFrameHostname);
        }
      }
    };
  }
};

var RallyPayReact = function RallyPayReact(_ref) {
  var claimsInfoPacket = _ref.claimsInfoPacket,
      environment = _ref.environment,
      locale = _ref.locale,
      setPostMessage = _ref.setPostMessage,
      onSubmit = _ref.onSubmit,
      token = _ref.token;
  var iframeRef = React.useRef(null);
  React.useEffect(function () {
    window.addEventListener('message', handleMessage, false);

    if (setPostMessage) {
      setPostMessage(postMessage);
    }

    return function () {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  var iFrameHostname = determineEnvironment(environment);

  if (!iFrameHostname) {
    throw new RallyPayError('Widget not found! Please provide a valid environment.');
  }

  var postMessage = function postMessage(message) {
    // Since this function will only be exposed to the outside in useEffect
    // it seems the condition below will always be true, therefore
    // I was not able to follow the else path in test(I left the if to be 100% safe),
    // the comment bellow is for istanbul to ignore that path when calculating branch coverage

    /* istanbul ignore else  */
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(message, iFrameHostname);
    }
  };

  var handleMessage = dist_4(onSubmit, [iFrameHostname]);
  var iframeSource = generateIframePath(iFrameHostname, {
    claimsInfoPacket: claimsInfoPacket,
    locale: locale,
    token: token
  });
  return React__default.createElement("iframe", {
    src: iframeSource,
    ref: iframeRef,
    "data-testid": "iframe"
  });
};

exports.default = RallyPay;
exports.RallyPayReact = RallyPayReact;
exports.MessageType = dist_3;
